import { CompanyDetailOutput } from './company-detail-output.model';


export class CompanyAllDetailSelectByIdOutput implements ICompanyAllDetailSelectByIdOutput {
    status!: number;
    message!: string;
    data!: CompanyDetailOutput;

    constructor(data?: ICompanyAllDetailSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CompanyDetailOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyAllDetailSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyAllDetailSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompanyAllDetailSelectByIdOutput {
    status: number;
    message: string;
    data: CompanyDetailOutput;
}

